import Stack from "@mui/material/Stack"
import Divider from "@mui/material/Divider"
import HorarioComponent from "./HorarioComponent/HorarioComponent"
import HeatmapComponent from "./HeatmapComponent/HeatmapComponent"
import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	Typography,
} from "@mui/material"

function EntrenoTabComponent() {
	return (
		<Stack
			direction="column"
			spacing={1}
			divider={<Divider orientation="horizontal" flexItem />}
		>
			<HorarioComponent />
			<br></br>
			<div className="content">
				<h1 className="entrenamientos-component-text">
					<span>Ejercicios</span>
					<br></br>
				</h1>
				<span>
					<span>
						A continuación podéis encontrar los todos los ejercicios que se han
						preparado para esta temporada:
					</span>
				</span>
			</div>

			<HeatmapComponent />

			<div className="content">
				<Typography variant="h5">
					Significado de las siglas que aparecen en los ejercicios:{" "}
				</Typography>
				<List>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>AMRAP:</b> As Many Reps As Possible. La idea es hacer el mayor
							numero de veces todos los ejericios hasta que se termine el
							tiempo.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>HUHO:</b> Half Under Half Over. Medio largo por abajo y medio
							por arriba.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>ExMOxM:</b> Every X Minutes ON the X Minutes. Hacer
							repeticiones de un ejercicio cada X minutos.
						</ListItemText>
					</ListItem>
					<ListItem>
						<ListItemIcon>-</ListItemIcon>
						<ListItemText>
							<b>FOR TIME:</b> Hay que acabar todos los ejercicios antes de que
							se acabe el tiempo!
						</ListItemText>
					</ListItem>
				</List>
			</div>
		</Stack>
	)
}

export default EntrenoTabComponent
